class CategoryDescription {
    constructor() {
        console.log('CategoryDescription: Initializing');
        this.init();
    }

    init() {
        const descriptions = document.querySelectorAll('.category-description');
        console.log('CategoryDescription: Found', descriptions.length, 'descriptions');
        
        if (!descriptions.length) return;

        descriptions.forEach(description => {
            this.setupDescription(description);
        });
    }

    setupDescription(description) {
        const content = description.querySelector('.description-content');
        const toggle = description.querySelector('.description-toggle');
        
        console.log('CategoryDescription: Setting up description', {
            content: content,
            toggle: toggle
        });

        if (!content || !toggle) return;

        // 默认添加折叠状态
        content.classList.add('is-collapsed');

        // 设置初始状态
        this.checkOverflow(content, toggle);

        // 绑定点击事件
        toggle.addEventListener('click', () => {
            this.toggleDescription(content, toggle);
        });

        // 监听窗口大小变化
        window.addEventListener('resize', () => {
            this.checkOverflow(content, toggle);
        });
    }

    checkOverflow(content, toggle) {
        // 临时移除最大高度以获取真实高度
        const originalMaxHeight = content.style.maxHeight;
        content.style.maxHeight = 'none';
        const scrollHeight = content.scrollHeight;
        content.style.maxHeight = originalMaxHeight;

        // 如果内容高度超过 120px 显示切换按钮
        const shouldCollapse = scrollHeight > 120;
        toggle.style.display = shouldCollapse ? 'flex' : 'none';

        // 如果不需要折叠，移除折叠状态
        if (!shouldCollapse) {
            content.classList.remove('is-collapsed');
            content.style.maxHeight = 'none';
        } else if (!content.classList.contains('is-expanded')) {
            content.classList.add('is-collapsed');
            content.style.maxHeight = '120px';
        }
    }

    toggleDescription(content, toggle) {
        const isExpanded = content.classList.contains('is-expanded');
        
        // 更新状态
        toggle.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('is-expanded');
        content.classList.toggle('is-collapsed');

        // 更新按钮文本
        const toggleText = toggle.querySelector('.toggle-text');
        if (toggleText) {
            toggleText.textContent = isExpanded ? 'Show More' : 'Show Less';
        }

        // 更新内容高度
        if (isExpanded) {
            content.style.maxHeight = '120px';
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }
}

// 导出组件
export default CategoryDescription; 